<template>
	<v-main>
		<v-tabs v-model="tab" grow> 
			<v-tab href="#profile">Profile</v-tab>
			<v-tab href="#dashboard" v-if="userType === 'Front-End Admin'">
					Dashboard
					<v-select class="optionContext" v-if="userType === 'Front-End Admin'" 
						v-model="optionSelected" color="#000" 
						background-color="transparent" style="margin-left: -5%; max-width: 70px;" 
						:items="options" item-text="text" item-value="value">
					</v-select>
			</v-tab>
			<v-tab v-if="userType === 'Front-End Admin'" href="#manage">Manage</v-tab>
			<v-tab href="#courses">Assigned Courses</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
			<v-tab-item value="dashboard" v-if="userType === 'Front-End Admin'">
				<dashboard-profile :option="optionSelected" :guid="guid"/>
			</v-tab-item>
            <v-tab-item value="profile">
                <v-form ref="form" v-model="valid" @submit.prevent="editProfile()" class="pa-4">
					<v-row class="d-flex justify-center align-center my-6">
						<v-badge :value="hover" icon="mdi-camera" avatar bottom bordered overlap color="black" offset-x="40" offset-y="40" style="margin-left: 40px">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-hover v-model="hover">
										<v-avatar v-on="on" v-bind="attrs" size="200" class="mb-4" style="cursor: pointer;" @click="openFileDialog">
											<v-img sizes="200" v-if="entity.image && entity.image.startsWith('data')" :src="entity.image"></v-img>
											<v-img sizes="200" v-else-if="entity.image && entity.image !== 'undefined' && !imgError" :src="baseLocation + '/asset/file/user/' + entity.image" @error="imgError = !imgError"></v-img>
											<v-icon v-else size="200">mdi-account-circle</v-icon>
										</v-avatar>
									</v-hover>
								</template>
								<span>It’s recommended to use image with resolution approximately 200 x 200 pixels and recommended size is under 500KB</span>
							</v-tooltip>
						</v-badge>
						<input type="file" ref="attachment" accept="image/png, image/jpeg, image/jpg" style="display: none;" @change="showImage" required />
						
						<v-col cols="12" sm="5" style="padding-left:50px; padding-right: 45px;">
							<v-text-field v-model="entity.firstName" label="First Name" :rules="[(v) => !!v || 'First name is required']" dense rounded filled required></v-text-field>
							<v-text-field v-model="entity.lastName" label="Last Name" :rules="[(v) => !!v || 'Last name is required']" dense rounded filled required></v-text-field>
							<v-btn class="v-unite-primary px-8" type="submit" rounded color="green" @click="moveToChangePassword">Change Password</v-btn>
						</v-col>
					</v-row>

					<!-- Alert, Title, Company, Bio -->
					<v-row v-if="alert.message" class="d-flex justify-center align-center">
						<v-col cols="12" sm="6">
							<v-alert v-model="alert.show" :type="alert.type" dismissible>{{alert.message}}</v-alert>
						</v-col>
					</v-row>
					<v-row class="d-flex justify-center align-center">
						<v-col cols="12" sm="6">
							<v-text-field v-model="entity.telephone" label="Telephone" dense rounded filled hide-details required></v-text-field>
						</v-col>
					</v-row>
					<v-row class="d-flex justify-center align-center">
						<v-col cols="12" sm="3">
							<v-text-field v-model="entity.title" label="Title" dense rounded filled hide-details required></v-text-field>
						</v-col>
						<v-col cols="12" sm="3">
							<v-text-field v-model="entity.company" label="Company" dense rounded filled hide-details required></v-text-field>
						</v-col>
					</v-row>
					<v-row class="d-flex justify-center align-center">
						<v-col cols="12" sm="3">
							<v-text-field v-model="entity.city" label="City" dense rounded filled hide-details required></v-text-field>
						</v-col>
						<v-col cols="12" sm="3">
							<v-text-field v-model="entity.state" label="State" dense rounded filled hide-details required></v-text-field>
						</v-col>
					</v-row>
					<v-row class="d-flex justify-center align-center">
						<v-col cols="12" sm="6">
							<v-textarea v-model="entity.bio" label="Bio" dense filled rounded hide-details no-resize></v-textarea>
						</v-col>
					</v-row>

					<v-row class="d-flex" justify="center" v-if="isLinksActive">
						<v-col cols="12" sm="6">
							<h2>Medspa Links</h2>
							<v-row class="d-flex justify-center align-center my-6">
								<v-btn  class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Dashboard')">Dashboard</v-btn>
							</v-row>
							
							<v-row v-if="isPracticeOwner || isPracticeEmployee" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Assigned Training')">View Assigned Training</v-btn>
							</v-row>
							<v-row v-if="isPracticeOwner || isPracticeEmployee" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Completed Training')">View Completed Training</v-btn>
							</v-row>

							<v-row v-if="isPracticeOwner" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Manage Employee')">Manage Employee & Assign Training</v-btn>
							</v-row>
							
							<v-row v-if="isPracticeEmployee" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Certificates Achieved')">View Certificates Achieved</v-btn>
							</v-row>

							<v-row v-if="isPracticeAdmin" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Manage Categories')">Manage Categories</v-btn>
							</v-row>
							<v-row v-if="isPracticeAdmin" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Manage Modules')">Manage Modules</v-btn>
							</v-row>
							<v-row v-if="isPracticeAdmin" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Manage Accounts')">Manage Accounts</v-btn>
							</v-row>
							<v-row v-if="isPracticeAdmin" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Customize Dashboards')">Customize Dashboards</v-btn>
							</v-row>
							<v-row v-if="isPracticeAdmin" class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Reporting')">Reporting</v-btn>
							</v-row>

							<v-row class="d-flex justify-center align-center my-6">
								<v-btn class="v-unite-primary px-8" rounded color="green" style="width: 85%;" @click="getLink('Account Profile')">Account Profile</v-btn>
							</v-row>
						</v-col>
					</v-row>

					<v-row class="d-flex" justify="center">
						<v-col cols="12" sm="6">
							<h2>Add your business card</h2>
							<v-row class="d-flex" justify="center">
							<v-col class="d-flex flex-column justify-center align-center my-6">
								<v-badge :value="hoverFrontCard" icon="mdi-camera" avatar bottom bordered overlap color="black" offset-x="40" offset-y="40">
									<v-btn
										v-if="(entity.businessCardFrontImg && entity.businessCardFrontImg.startsWith('data')) || entity.businessCardFrontImg" 
										class="d-flex flex-column ma-2"
										color="error"
										style="position: absolute; z-index:1; right: 0px"
										fab
										small
										@click="entity.businessCardFrontImg =''"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-hover v-model="hoverFrontCard">
												<div v-on="on" v-bind="attrs"  class="text-center" style="cursor: pointer; width: 420px; height: 240px; background-color:#EEEEEE;" @click="openBusinessCardFrontDialog">
													<v-img v-if="entity.businessCardFrontImg && entity.businessCardFrontImg.startsWith('data')" :src="entity.businessCardFrontImg" max-width="420px" max-height="240" contain></v-img>
													<v-img v-else-if="entity.businessCardFrontImg" :src="baseLocation + '/asset/file/businesscard/' + entity.businessCardFrontImg+ '?c=' + imgCaching" @error="imgError = !imgError" max-width="420px" max-height="240" contain></v-img>
													<v-row v-else justify="center" class="d-flex flex-column">
														<v-icon size="90" style="padding: 30px">mdi-image-outline</v-icon>
														<h2>Upload image of front</h2>
													</v-row>
												</div>
											</v-hover>
										</template>
										<span>It’s recommended to use image with resolution approximately 1050 x 600 pixels</span>
									</v-tooltip>
								</v-badge>
								<input type="file" ref="attachment1" accept="image/png, image/jpeg, image/jpg" style="display: none;" @change="showFrontCardImage" required />
							</v-col>
							<v-col class="d-flex flex-column justify-center align-center my-6" >
								<v-badge :value="hoverBackCard" icon="mdi-camera" avatar bottom bordered overlap color="black" offset-x="40" offset-y="40">
									<v-btn
										v-if="(entity.businessCardBackImg && entity.businessCardBackImg.startsWith('data')) || entity.businessCardBackImg" 
										class="d-flex flex-column ma-2"
										color="error"
										style="position: absolute; z-index:1; right: 0px"
										fab
										small
										@click="entity.businessCardBackImg =''"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-hover v-model="hoverBackCard">
												<div v-on="on" v-bind="attrs"  class="text-center" style="cursor: pointer; width: 420px; height: 240px; background-color:#EEEEEE;" @click="openBusinessCardBackDialog">
													<v-img v-if="entity.businessCardBackImg && entity.businessCardBackImg.startsWith('data')" :src="entity.businessCardBackImg" max-width="420px" max-height="240" contain></v-img>
													<v-img v-else-if="entity.businessCardBackImg" :src="baseLocation + '/asset/file/businesscard/' + entity.businessCardBackImg+ '?c=' + imgCaching" @error="imgError = !imgError" max-width="420px" max-height="240" contain></v-img>
													<v-row v-else justify="center" class="d-flex flex-column">
														<v-icon size="90" style="padding: 30px">mdi-image-outline</v-icon>
														<h2>Upload image of back</h2>
													</v-row>
												</div>
											</v-hover>
										</template>
										<span>It’s recommended to use image with resolution approximately 1050 x 600 pixels</span>
									</v-tooltip>
								</v-badge>
								<input type="file" ref="attachment2" accept="image/png, image/jpeg, image/jpg" style="display: none;" @change="showBackCardImage" required />
							</v-col>
							</v-row>
						</v-col>
					</v-row>

					<v-row v-if="showAddInterests == false" class="d-flex justify-center align-center">
						<v-col cols="12" sm="6">
							<h2>Interests</h2>
							<div style="max-height:200px; overflow: auto;">
								<v-chip class="v-unite-primary-color" v-for="item in entity.interestNameList" :key="item" :value="item" style="margin-right: 5px">{{item}}</v-chip>
							</div>
						</v-col>
					</v-row>
					<v-row v-if="showAddInterests == false" class="d-flex justify-center align-center">
						<v-col cols="12" sm="6">
							<v-btn @click="listInterest(); showAddInterests = true" class="v-unite-primary px-8" rounded>Add Interests</v-btn>
						</v-col>
					</v-row>

					<v-row v-if="showAddInterests == true" class="d-flex justify-center align-center">
						<v-col cols="12" sm="6">
							<h2>Add your interests</h2>
							<div class="frame-interests" style="max-height:200px; overflow: auto;">
								<v-chip-group v-model="entity.interestList" active-class="v-unite-primary-color" column multiple>
									<v-chip v-for="item in interestList" :key="item.id" :value="item.id">{{item.name}}</v-chip>
								</v-chip-group>
							</div>
						</v-col>
					</v-row>

					<!-- Availability -->
					<v-row class="d-flex justify-center align-center">
						<v-col cols="12" sm="3">
							<h2> Add your availability </h2>
							Select the times you are available to chat and meet
						</v-col>
						<v-col cols="12" sm="3">
							<v-menu
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								max-width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										class="pt-5"
										v-model="dateRangeText"
										label="Select Availability Date"
										prepend-icon="mdi-calendar-range"
										v-bind="attrs"
										v-on="on"
										dense
										autocomplete="off"
										hide-details=""
									></v-text-field>
								</template>
								<v-date-picker
									v-model="filterAvailability"
									:min="startAvailability"
									:max="endAvailability"
									range
									color="primary"
									no-title
								></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
					<v-row class="d-flex justify-center align-center" v-for="(availability, index) in availabilityListTemp" :key="index">
						<v-col cols="12" sm="6">
							<span> {{availability.name + " " + experience.transitMap.timezoneName}} </span>
							<br>
							<v-chip 
								v-for="(hour, idxHour) in availability.hourList" :key="availability.name + '_' + idxHour"
								class="ma-1 justify-center"  
								style="width: 75px"
								:style="{
									backgroundColor: hour.background_color,
									color: hour.font_color
								}" 
								@click="changeColorAndStatus(hour, '#3b5a5f')"
								v-show="hour.isShow"
							> {{formatTime(hour.name)}} </v-chip>
						</v-col>
					</v-row>

					<v-row class="d-flex justify-center align-center">
						<v-btn :disabled="!valid" class="v-unite-primary px-8" type="submit" rounded>Save</v-btn>
					</v-row>
				</v-form>
            </v-tab-item>

			<v-tab-item value="manage">
				<manage-training :guid="guid" :usertype="userType"/>
			</v-tab-item>

            <v-tab-item value="courses">
                <assign-course/>
            </v-tab-item>
        </v-tabs-items>

		
		<v-dialog
			v-model="dialogPopup.show"
			v-if="dialogPopup.show"
			no-click-animation
			persistent
			style="overflow: hidden;"
			:fullscreen="isMaxDialog"
		>
			<v-card style="height:600px; margin: auto; padding: 0px;">
				<v-card-title class="headline" style="background-color: #faa534; color: #ffffff;">
					{{dialogPopup.title}}
					<v-spacer></v-spacer>
					<v-btn
                        icon
                        @click="isMaxDialog == false ? maximizeDialogUrl() : minimizeDialogUrl()"
                    >
                        <v-icon v-if="isMaxDialog">mdi-window-restore</v-icon>
						<v-icon v-else>mdi-window-maximize</v-icon>
                    </v-btn>
					<v-btn
						icon
						@click="dialogPopup.show = false;"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
					<div id="spinner" style="position:absolute">
						<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
					</div>
					<iframe
						style="border:1px solid #e0e0e0; position: absolute" 
						width="100%"
						height="88%"
						:src=dialogPopup.value
						allow="camera;microphone"
						onload="document.getElementById('spinner').style.display='none';"
						allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
					>
					</iframe>
			</v-card>
		</v-dialog>

	</v-main>
</template>

<style>
.optionContext.v-text-field>.v-input__control>.v-input__slot:before {
	border-style: none;
}
.optionContext.v-text-field>.v-input__control>.v-input__slot:after {
	border-style: none;
}

.optionContext .v-select__selection,
.optionContext .v-select__selection--comma,
.optionContext .v-select.v-text-field input {
	color: transparent !important;
}
.v-unite-primary-color {
	background-color: #eb6e1f !important;
	font-weight: bold;
	text-decoration: none;
	color: white;
}
.frame-interests::-webkit-scrollbar {
    -webkit-appearance: none;
}

.frame-interests::-webkit-scrollbar:vertical {
    width: 11px;
}

.frame-interests::-webkit-scrollbar:horizontal {
    height: 11px;
}

.frame-interests::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; 
    background-color: rgba(0, 0, 0, .5);
}

.frame-interests::-webkit-scrollbar-track { 
    background-color: #fff; 
    border-radius: 8px; 
} 
</style>

<script>
import axios from "axios";
import { CometChat } from "@cometchat-pro/chat";
import configuration from "../../configuration";
import AssignCourse from "./profiletab/assignCourse";
import ManageTraining from "./profiletab/manage";
import DashboardProfile from "./profiletab/dashboard";

export default {
	components: { AssignCourse, ManageTraining, DashboardProfile },
	props: ["tenantSlug", "experienceSlug"],
	data() {
		return {
			optionSelected: 0,
			options: [
				{ text: "Experience", value: 0 },
				{ text: "Training", value: 1}
			],
			userType: '',
			tab: null,

			isPracticeOwner: false,
			isPracticeEmployee: false,
			isPracticeAdmin: false,
			isLinksActive: false,
			medspaToken: "",
			
			dialogPopup: {show: false, title: "", value: ""},

			hover: false,
			hoverFrontCard: false,
			hoverBackCard: false,
			valid: true,
			entity: {availabilityList: []},
			interestList: [],
			showAddInterests: true,
			attachment: null,
			attachment1: null,
			attachment2: null,
			alert: { show: false, message: "" },
			baseLocation: axios.defaults.baseURL,
			imgError: false,
            availabilityList: [],
            availabilityListTemp: [],
            experience: {},
            weekdays: [
                "Sunday", 
                "Monday", 
                "Tuesday", 
                "Wednesday", 
                "Thursday", 
                "Friday", 
                "Saturday"
            ],
			imgCaching: this.$root.randomNumber(),
			filterAvailability: [],
			startAvailability: "",
			endAvailability: "",
			isMaxDialog: false,
			guid: '',
		};
	},
	mounted() {
		axios
				.post("/system/user/guid/find",  {id: this.$store.state.principal.id})
				.then(response => {
					this.guid = response.data;

					axios.post("system/user/find",  {id: this.$store.state.principal.id})
					.then(rep => {
						this.userType = rep.data.userType;
					})

				})
				.catch(() => {});

		// TODO : change tenant slug to Medspa 
		
		// local
		// if ( this.$store.state.principal.tenantSlug === "belindexhibition" && this.$store.state.principal.experienceSlug === "bbw") {
		
		// staging
		if ( this.$store.state.principal.tenantSlug === "belindexhibition" && this.$store.state.principal.experienceSlug === "medspabizuniversitystaging") {

		// production
		// if ( this.$store.state.principal.tenantSlug === "insparationmanagement" && this.$store.state.principal.experienceSlug === "medspabizuniversity") {
			
			this.isLinksActive = true;

			// get Medspa user type here 
			if (this.$store.state.principal.medspaType === "Free (Clinic)") {
				this.isPracticeOwner = true;
			} else if (this.$store.state.principal.medspaType === "Employee") {
				this.isPracticeEmployee = true;
			} else if (this.$store.state.principal.medspaType === "Brand (Master)" || this.$store.state.principal.medspaType === "Admin") {
				this.isPracticeAdmin = true;
			}

			this.medspaToken = this.$store.state.principal.medspaToken;
			
		}

		this.getExperienceUser();
		if (this.$root.showLiveSupport) {
			this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
		}
	},
	computed: {
		dateRangeText () {
			this.findAvailability();
			return this.filterAvailability.join(' - ')
		},
	},
	methods: {
		maximizeDialogUrl() {
            this.isMaxDialog = true;
        },
		minimizeDialogUrl() {
            this.isMaxDialog = false;
        },
		getLink(e) {
			this.dialogPopup.show = true;
			this.dialogPopup.title = e;

			var medspaURL = this.$medspaurl + "/account/";
			var param = "frame=" + this.$store.state.principal.medspaToken;

			axios
				.post("/system/user/find", {id: this.$store.state.principal.id})
				.then(response => {

					if (this.$store.state.principal.medspaToken != response.data.medspaToken) {
						this.$store.commit("updatePrincipal", response.data);
						param = "frame=" + this.$store.state.principal.medspaToken;
					} 

					if (e === "Dashboard") {
						this.dialogPopup.value = medspaURL + "dashboard?" + param;
					} else if (e === "Assigned Training") {

						this.dialogPopup.value = medspaURL + "take-training?" + param;
					} else if (e === "Completed Training") {

						this.dialogPopup.value = medspaURL + "completed-training?" + param;
					} else if (e === "Manage Employee") {
					
						this.dialogPopup.value = medspaURL + "manage-employees?" + param;
					} else if (e === "Manage Categories") {
					
						this.dialogPopup.value = medspaURL + "manage-categories?" + param;
					} else if (e === "Certificates Achieved") {
					
						this.dialogPopup.value = medspaURL + "certificates?" + param;
					} else if (e === "Manage Accounts") {
					
						this.dialogPopup.value = medspaURL + "manage-accounts?" + param;
					} else if (e === "Manage Modules") {
						
						this.dialogPopup.value = medspaURL + "manage-modules?" + param;
					} else if (e === "Customize Dashboards") {
						
						this.dialogPopup.value = medspaURL + "customize?" + param;
					} else if (e === "Reporting") {
						
						this.dialogPopup.value = medspaURL + "sub_reporting?" + param;
					} else if (e === "Account Profile") {
						
						this.dialogPopup.value = medspaURL + "profile?" + param;
					} 
					else {

						this.dialogPopup.value = "https://www.bing.com";
					}
				})
				.catch(() => {});

		},
		getExperienceUser() {
			axios
				.get("/system/user")
				.then(response => {
					this.entity = response.data;
					this.entity.image = this.$store.state.principal.image;
					if(this.entity.interestList.length > 0){
						this.showAddInterests = false;
					} else {
						this.listInterest();
					}
                    this.getExperience();
				})
				.catch(() => {});
		},
        getExperience() {
            axios
                .get("/system/experience/find")
                .then((response) => {
                    this.experience = response.data;
                    this.setAvailability();
                })
                .catch(() => {});
        },
		openFileDialog() {
			this.$refs.attachment.click();
		},
		openBusinessCardFrontDialog() {
			this.$refs.attachment1.click();
		},
		openBusinessCardBackDialog() {
			this.$refs.attachment2.click();
		},
		showImage(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entity.image = fr.result;
					this.attachment = files[0]; // this is an image file that can be sent to server...
				});
			} else {
				this.attachment = null;
			}
		},
		showFrontCardImage(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entity.businessCardFrontImg = fr.result;
				});
				this.attachment1 = files[0];
			} else {
				this.attachment1 = null;
			}
		},
		showBackCardImage(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entity.businessCardBackImg = fr.result;
				});
				this.attachment2 = files[0];
			} else {
				this.attachment2 = null;
			}
		},
		listInterest(){
			axios
				.get("/system/interest/experience/list")
				.then((response) => {
					this.interestList = response.data;
					})
				.catch(() => {});
		},
		editProfile() {
			this.alert.show = false;
			let formData = new FormData();
            this.entity.availabilityList = this.availabilityList;
			formData.append("entity", JSON.stringify(this.entity));
			formData.append("interestUpdateFlag", this.showAddInterests);
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}

			axios
				.post("/system/user/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(async response => {
					this.$store.commit("updatePrincipal", response.data);
					[this.alert.type, this.alert.message, this.alert.show] = [
						"success",
						"Profile updated successfully, please logout and login again to see your updated profile.",
						true
					];
					this.$refs.form.resetValidation();

					if(!this.$store.state.principal.chatUserToken) {
						let cometchatUser = await CometChat.getUser(this.entity.chatId);
						await CometChat.updateUser(cometchatUser, configuration.apiKeyCometChat);
					}
				})
				.catch(() => {});
		}, 
		listHour(start) {
            let hourList = [];
            for (let i = start; i < 26; i++) {
                let sHour = 7 + (0.5 * i);
                let eHour = sHour + 0.5;

                let tSHour = this.formatTime(sHour);
                let tEHour = this.formatTime(eHour);

                let hour = {
                    "name": sHour,
                    "rangeName": tSHour + "-" + tEHour,
                    "status": false,
                    "background_color": "#e0e0e0",
                    "font_color": "black",
                }
                hourList.push(hour);
            }
            return hourList;
        },
        formatTime(time) {
            time = time >= 13 ? (time-12) : time
            return time.toString().replace(".5" , ".30")
        },
        changeColorAndStatus(element, disiredColor) {
            if (!element.status){
                element.background_color = disiredColor;
                element.font_color = "white";
            } else {
                element.background_color = "#e0e0e0";
                element.font_color = "black";
            }
            element.status = !element.status;
        },
        setAvailability() {
			this.setMinAndMaxDateAvaibility();
            let startDate = this.getDate(this.experience.startDate);
            let endDate = this.getDate(this.experience.endDate);
            
            var DifferenceInTime = endDate.getTime() - startDate.getTime();
            var DifferenceInDays = Math.floor(DifferenceInTime / (1000 * 3600 * 24));

			if (!this.entity.availabilityList) {
				for (let i = 0; i <= DifferenceInDays; i++) {
					let availability = {
						"name": "Day " + (i+1) + " " + this.formatDate(startDate),
						"hourList": this.listHour(0)
					}

					for (let hour of availability.hourList) {
						hour.isShow = true;
						if ((this.experience.id == 1026607)) {
							if (parseFloat(hour.name) >= 7 && parseFloat(hour.name) < 15) {
								hour.isShow = false;
							}
						}
					}
					this.availabilityList.push(availability);
					startDate.setDate(startDate.getDate() + 1);
				}
			} else {
				for (let i = 0; i <= DifferenceInDays; i++) {
					let availability = null;
					let date = this.formatDate(startDate);

					for (let dbAvailability of this.entity.availabilityList) {
						let split = dbAvailability.name.split(" ");
						let tDate = split[2] + " " + split[3] + " " + split[4] + " " + split[5];

						if (date == tDate) {
							availability = dbAvailability;
						}
					}

					if (!availability) {
						availability = {
							"name": "Day " + (i+1) + " " + date,
							"hourList": this.listHour(0)
						}
					} else {
						if(availability.hourList.length == 22) {
							let tmpList = this.listHour(22);
							for (let tmp of tmpList) {
								availability.hourList.push(tmp);
							}
						}
					}

					for (let hour of availability.hourList) {
						hour.isShow = true;
						if ((this.experience.id == 1026607)) {
							if (parseFloat(hour.name) >= 7 && parseFloat(hour.name) < 15) {
								hour.isShow = false;
							}
						}
					}

					this.availabilityList.push(availability);
					startDate.setDate(startDate.getDate() + 1);
				}
			}
        },
        getDate(date) {
			if (date) {
				return new Date(
					date.date.year, 
					date.date.month-1, 
					date.date.day
				);
			} else {
				return new Date();
			}
        },
        formatDate(date) {
            let options = {
                year: "numeric",
                month: "long",
                day: "numeric"
            };
            let formattedDate = date.toLocaleString("en-US", options).split(" ");
            let result =
                this.weekdays[date.getDay()] +
                " " +
                formattedDate[1].replace(",", "") +
                " " +
                formattedDate[0] +
                " " +
                formattedDate[2].replace(",", "");
            return result;
        },
		moveToChangePassword() {
			window.location.href = '/#/' + this.tenantSlug + '/' + this.experienceSlug + '/changepassword';
		},
		findAvailability() {
			if (this.filterAvailability.length > 0) {
				this.filterAvailability.sort();
				let dateSplit = this.filterAvailability[0].split("-");
				let startDate = this.formatDate(new Date(dateSplit[0], dateSplit[1]-1, dateSplit[2]));
				let endDate = startDate;
				
				if (this.filterAvailability[1]) {
					dateSplit = this.filterAvailability[1].split("-");
					endDate = this.formatDate(new Date(dateSplit[0], dateSplit[1]-1, dateSplit[2]));
				}

				this.availabilityListTemp = [];
				let statusAdd = false;
				for (let i = 0; i < this.availabilityList.length; i++) {
					let name = this.availabilityList[i].name;
					if (name.endsWith(startDate)) {
						statusAdd = true;
					}
					if (statusAdd) {
						this.availabilityListTemp.push(this.availabilityList[i]);
					}
					if (name.endsWith(endDate)) {
						statusAdd = false;
					}
				}
			}
		},
		setMinAndMaxDateAvaibility() {
			this.startAvailability = this.experience.startDate.date.year + '-' + this.setTwoDigitFormat(this.experience.startDate.date.month) + '-' + this.setTwoDigitFormat(this.experience.startDate.date.day);
			this.endAvailability = this.experience.endDate.date.year + '-' + this.setTwoDigitFormat(this.experience.endDate.date.month) + '-' + this.setTwoDigitFormat(this.experience.endDate.date.day);
		},
		setTwoDigitFormat(value){
			if (value.toString().length === 1) {
				return '0' + value;
			}
			return value;
		}

	}
};
</script>